import { useState } from "react";

export const GoldImage = ({ src, alt = "", className = "", label = "" }) => {
    const [err, setErr] = useState(false);
    if (!src || err) {
        return (
            <div
                className={`flex items-center justify-center bg-[#121216] ${className}`}
                style={{
                    backgroundImage:
                        "radial-gradient(ellipse 70% 60% at 30% 20%, rgba(212,175,55,0.12), transparent 60%), radial-gradient(ellipse 50% 50% at 80% 90%, rgba(153,122,21,0.10), transparent 60%)",
                }}
                role="img"
                aria-label={alt || "TOURVOYAGERS"}
            >
                <div className="text-center px-4">
                    <svg width="52" height="52" viewBox="0 0 64 64" className="mx-auto opacity-80" aria-hidden="true">
                        <rect width="64" height="64" rx="14" fill="none" stroke="rgba(212,175,55,0.35)" strokeWidth="1" />
                        <circle cx="32" cy="32" r="21" fill="none" stroke="#D4AF37" strokeWidth="1.2" />
                        <text x="32" y="40" fontFamily="Cinzel, Georgia, serif" fontSize="20" fill="#D4AF37" textAnchor="middle">TV</text>
                    </svg>
                    {label && <p className="mt-3 font-mono-accent text-[10px] tracking-[0.3em] text-amber-500/70 uppercase">{label}</p>}
                </div>
            </div>
        );
    }
    return <img src={src} alt={alt} loading="lazy" onError={() => setErr(true)} className={className} />;
};
